import { Box, Button, Card, Typography } from '@mui/material';
import React from 'react';
import ArrowReturnIcon from '../../../../../svg-icons/ArrowReturnIcon';
import SAVOrderIcon from '../../../../../svg-icons/SAVOrderIcon';

export const SavOrderHeader = ({ handleShowComponent }) => {
  return (
    <Card
      elevation={5}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        padding: 2,
        mb: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <SAVOrderIcon fontSize="small" color="primary" />
          <Typography color="primary">Formulaire de commande SAV</Typography>
        </Box>
        <Button
          onClick={() => handleShowComponent(null)}
          variant="outlined"
          size="small"
          sx={{ position: 'absolute', top: 16, left: 16 }}
        >
          <ArrowReturnIcon fontSize="small" />
          <span style={{ marginLeft: 4, fontSize: '0.9em' }}>Retour</span>
        </Button>
      </Box>
    </Card>
  );
};
